var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 865,
    height: 704,
    viewBox: "0 0 865 704",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.178 178.699L322.892 205.964L211.301 141.215L260.285 113.959L370.178 178.699Z",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.178 322.673L322.892 349.929L211.301 285.189L260.285 257.925L370.178 322.673Z",
    stroke: "#231F20",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.909 322.673L322.623 349.929L211.031 285.189L260.015 257.925L369.909 322.673Z",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.891 205.964V349.93",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.711 113.959V257.925L211.348 285.142V141.168",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.18 178.226V322.199",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.721 259.63L175.436 286.894L63.8359 222.146L112.82 194.89L222.721 259.63Z",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.721 403.596L175.436 430.86L63.8359 366.12L112.82 338.855L222.721 403.596Z",
    stroke: "#231F20",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.444 403.596L175.166 430.86L63.5664 366.12L112.55 338.855L222.444 403.596Z",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.434 286.895V430.86",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.246 194.89V338.856L63.8828 366.072V222.098",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.723 259.156V403.13",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M671.631 250.681L624.354 277.945L512.754 213.205L561.738 185.94L671.631 250.681Z",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.631 394.655L624.354 421.919L512.754 357.17L561.738 329.914L671.631 394.655Z",
    stroke: "#231F20",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.362 394.655L624.084 421.919L512.484 357.17L561.468 329.914L671.362 394.655Z",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.352 277.945V421.919",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.164 185.94V329.914L512.801 357.123V213.157",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.633 250.215V394.181",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M818.135 331.911L770.85 359.175L659.258 294.427L708.242 267.171L818.135 331.911Z",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.135 475.885L770.85 503.141L659.258 438.401L708.242 411.137L818.135 475.885Z",
    stroke: "#231F20",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.866 475.885L770.58 503.141L658.98 438.401L707.964 411.137L817.866 475.885Z",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.848 359.176V503.142",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.66 267.171V411.137L659.305 438.354V294.38",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.137 331.438V475.411",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.617 153.314L455.895 180.578L567.495 115.829L518.511 88.5732L408.617 153.314Z",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.617 297.287L455.895 324.544L567.495 259.803L518.511 232.539L408.617 297.287Z",
    stroke: "#231F20",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.887 297.287L456.165 324.544L567.764 259.803L518.78 232.539L408.887 297.287Z",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.895 180.578V324.544",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.086 88.5732V232.539L567.449 259.756V115.782",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.617 152.84V296.814",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.566 88.4475L351.844 115.704L463.444 50.9633L414.46 23.6992L304.566 88.4475Z",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.566 232.413L351.844 259.677L463.444 194.937L414.46 167.673L304.566 232.413Z",
    stroke: "#231F20",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.836 232.413L352.114 259.677L463.713 194.937L414.73 167.673L304.836 232.413Z",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.844 115.704V259.678",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.035 23.6992V167.673L463.398 194.89V50.9159",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.566 87.9736V231.947",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.719 530.659L463.004 557.916L574.604 493.175L525.62 465.919L415.719 530.659Z",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.719 674.626L463.004 701.89L574.604 637.15L525.62 609.886L415.719 674.626Z",
    stroke: "#231F20",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.996 674.626L463.274 701.89L574.874 637.15L525.89 609.886L415.996 674.626Z",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.004 557.916V701.89",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.191 465.919V609.885L574.554 637.102V493.128",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.719 530.186V674.159",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.887 466.093L370.172 493.349L481.772 428.609L432.788 401.345L322.887 466.093Z",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.887 610.059L370.172 637.323L481.772 572.575L432.788 545.318L322.887 610.059Z",
    stroke: "#231F20",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.164 610.059L370.442 637.323L482.041 572.575L433.058 545.318L323.164 610.059Z",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.172 493.35V637.323",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.359 401.345V545.319L481.722 572.527V428.561",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.887 465.619V609.585",
    stroke: "white",
    strokeWidth: 2.10878,
    strokeMiterlimit: 10
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.055 172.53L845.766 578.175",
    stroke: "white",
    strokeWidth: 12.6606,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.864 530.304L603.612 616.938L248.949 411.178L404.62 324.544L753.864 530.304Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.039 498.681L260.71 412.047",
    stroke: "white",
    strokeWidth: 12.6606,
    strokeMiterlimit: 10
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.127 381.733C358.916 381.109 357.265 380.636 355.448 380.122C358.852 374.57 362.162 369.191 365.597 363.584C363.844 363.141 362.391 362.778 360.693 362.352C363.876 356.428 366.995 350.631 370.249 344.573C368.267 344.281 366.632 344.044 364.413 343.712C371.466 333.753 375.565 322.616 379.814 310.88C384.245 322.482 388.107 333.721 395.365 343.704C393.146 344.02 391.456 344.257 389.434 344.549C392.68 350.56 395.792 356.31 399.038 362.32C397.434 362.723 395.997 363.086 394.086 363.568C397.513 369.136 400.846 374.554 404.274 380.13C402.402 380.651 400.744 381.109 398.58 381.71C402.916 387.894 407.086 393.825 411.651 400.333H384.34V421.816H375.446V400.483H347.953C352.558 393.92 356.728 387.973 361.127 381.71V381.733Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 5.27591,
    strokeMiterlimit: 10
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M544.714 435.93C543.221 435.503 542.1 435.187 540.875 434.84C543.182 431.088 545.409 427.447 547.739 423.664C546.554 423.364 545.567 423.119 544.422 422.835C546.57 418.831 548.679 414.913 550.882 410.814C549.54 410.617 548.434 410.451 546.933 410.237C551.704 403.5 554.468 395.974 557.343 388.044C560.336 395.887 562.95 403.485 567.855 410.237C566.354 410.451 565.209 410.617 563.843 410.806C566.039 414.866 568.139 418.759 570.335 422.819C569.253 423.096 568.282 423.34 566.986 423.664C569.3 427.432 571.559 431.088 573.873 434.864C572.61 435.219 571.488 435.527 570.019 435.93C572.949 440.108 575.769 444.12 578.857 448.519H560.391V463.044H554.381V448.622H535.797C538.909 444.183 541.728 440.163 544.706 435.93H544.714Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 5.27591,
    strokeMiterlimit: 10
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.233 540.579C616.741 540.153 615.619 539.837 614.395 539.489C616.701 535.738 618.928 532.097 621.258 528.314C620.074 528.013 619.086 527.769 617.941 527.484C620.089 523.48 622.198 519.563 624.402 515.463C623.059 515.266 621.953 515.1 620.453 514.887C625.223 508.15 627.987 500.623 630.862 492.693C633.856 500.536 636.47 508.134 641.375 514.887C639.874 515.1 638.729 515.266 637.362 515.456C639.558 519.515 641.659 523.409 643.855 527.469C642.773 527.745 641.801 527.99 640.506 528.314C642.82 532.081 645.079 535.738 647.393 539.513C646.129 539.868 645.008 540.177 643.539 540.579C646.469 544.757 649.289 548.77 652.377 553.169H633.911V567.693H627.901V553.272H609.316C612.428 548.833 615.248 544.813 618.225 540.579H618.233Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 5.27591,
    strokeMiterlimit: 10
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.162 394.963C326.643 394.252 324.763 393.715 322.702 393.13C326.58 386.812 330.339 380.683 334.257 374.301C332.259 373.796 330.608 373.385 328.673 372.896C332.298 366.159 335.844 359.548 339.556 352.653C337.298 352.321 335.434 352.045 332.906 351.674C340.939 340.332 345.598 327.656 350.44 314.292C355.487 327.498 359.878 340.3 368.147 351.666C365.62 352.029 363.693 352.297 361.387 352.629C365.083 359.469 368.629 366.024 372.325 372.864C370.501 373.322 368.858 373.741 366.694 374.286C370.596 380.628 374.395 386.796 378.296 393.146C376.164 393.739 374.276 394.26 371.812 394.947C376.748 401.984 381.495 408.745 386.692 416.153H355.597V440.614H345.472V416.327H314.164C319.408 408.855 324.155 402.087 329.162 394.947V394.963Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 5.27591,
    strokeMiterlimit: 10
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.807 402.656C497.288 401.945 495.408 401.408 493.346 400.824C497.224 394.505 500.984 388.376 504.901 381.995C502.903 381.489 501.252 381.079 499.317 380.589C502.943 373.852 506.489 367.241 510.201 360.346C507.942 360.015 506.078 359.738 503.551 359.367C511.583 348.025 516.243 335.349 521.084 321.985C526.131 335.191 530.523 347.994 538.792 359.359C536.264 359.722 534.337 359.991 532.031 360.323C535.727 367.162 539.274 373.718 542.97 380.557C541.145 381.015 539.503 381.434 537.339 381.979C541.24 388.321 545.039 394.49 548.941 400.84C546.808 401.432 544.921 401.953 542.457 402.64C547.393 409.678 552.14 416.438 557.337 423.847H526.242V448.307H516.117V424.02H484.809C490.053 416.549 494.8 409.78 499.807 402.64V402.656Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 5.27591,
    strokeMiterlimit: 10
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M578.834 562.813C576.315 562.103 574.435 561.565 572.374 560.981C576.252 554.663 580.011 548.534 583.929 542.152C581.93 541.647 580.28 541.236 578.345 540.746C581.97 534.009 585.516 527.398 589.228 520.503C586.969 520.172 585.105 519.895 582.578 519.524C590.61 508.182 595.27 495.506 600.112 482.143C605.159 495.348 609.55 508.151 617.819 519.516C615.292 519.879 613.365 520.148 611.058 520.48C614.755 527.319 618.301 533.875 621.997 540.715C620.173 541.173 618.53 541.591 616.366 542.136C620.268 548.478 624.067 554.647 627.968 560.997C625.836 561.589 623.948 562.11 621.484 562.798C626.42 569.835 631.167 576.595 636.364 584.004H605.269V608.464H595.144V584.178H563.836C569.08 576.706 573.827 569.937 578.834 562.798V562.813Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 5.27591,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M452.055 121.098L261.885 6L10 162.334L285.508 323.099",
    stroke: "white",
    strokeWidth: 9.49347,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M616.547 220.653L854.721 364.801L599.929 491.723L586.076 499.123L445.633 417.173",
    stroke: "white",
    strokeWidth: 9.49347,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M606.339 188.982L619.04 207.953V247.096L606.339 253.312L560.215 226.679V174.205V162.35L606.339 188.982Z",
    stroke: "white",
    strokeWidth: 8.44303,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M531.434 157.587L560.214 174.204",
    stroke: "white",
    strokeWidth: 8.44303,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M531.434 198.633L560.214 215.25",
    stroke: "white",
    strokeWidth: 8.44303,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M354.126 366.522C360.413 363.094 347.499 328.445 344.964 322.68C333.804 297.248 308.459 283.079 282.443 277.076C270.446 274.312 258.109 274.557 246.159 277.337C243.829 277.874 224.037 282.044 224.803 285.345C232.669 319.141 247.091 355.417 283.288 367.446C298.397 372.469 315.101 374.009 330.803 371.182C337.5 369.973 348.155 369.752 354.118 366.522H354.126Z",
    stroke: "white",
    strokeWidth: 8.44303,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.6241ffdf4d5123c308e408536359f3d8.svg";
export { ForwardRef as ReactComponent };